import { Hero } from "../components/site/Hero";
import { Marquee } from "../components/site/Marquee";
import { Services } from "../components/site/Services";
import { Founder } from "../components/site/Founder";
import { Process } from "../components/site/Process";
import { Stats } from "../components/site/Stats";
import { Payment } from "../components/site/Payment";
import { Testimonials } from "../components/site/Testimonials";
import { Gallery } from "../components/site/Gallery";
import { Faq } from "../components/site/Faq";
import { FinalCta } from "../components/site/FinalCta";

export default function Home() {
  return (
    <main>
      <Hero />
      <Marquee />
      <Services />
      <Founder />
      <Process />
      <Stats />
      <Payment />
      <Testimonials />
      <Gallery />
      <Faq />
      <FinalCta />
    </main>
  );
}
